import React from "react";
//#region types
import { MultiLineChartTitleProps } from "models/propTypes/chartProps";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const MultiLineChartTitle: React.FC<MultiLineChartTitleProps> = (props) => {
  return (
    <Grid container className={cssExports.chartSummary}>
      {props.rows.map((row, index) => (
        <Grid item key={index} container wrap="nowrap">
          <Grid item xs className={cssExports.chartSummaryText}>
            {row.title}
          </Grid>
          <Grid item className={cssExports.chartSummaryValue}>
            {row.value}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default MultiLineChartTitle;
